module.exports = __webpack_public_path__ + "static/img/C1.3e510bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/C1.png
// module id = PhNp
// module chunks = 0